/* eslint-disable import/prefer-default-export */
export const cleanup = (): { type: "session/cleanup" } => ({
  type: "session/cleanup",
});
